import ForgotPasswordComponent from "../components/auth/ForgotPassword";
const ForgotPassword = () => {
    return <ForgotPasswordComponent />;
};
export default ForgotPassword;
